<template>
  <dialog-base
    v-bind="$props"
    :header="$t('org.dialogs.newTermsDialog.headers.weValueYourPrivacyAndSecurity')"
    :loading="loading"
    max-width="100%"
    :value="showDialog"
    :hideCloseIcon="true"
    style="z-index: 20001">
    <template #activator="slotProps"></template>

    <template #body>
      <p>
        {{
          $t(
            'org.dialogs.newTermsDialog.messages.weMadeAFewChangesInOrderToMakeOpendockEvenSaferToUse'
          )
        }}
        <i18n-t
          keypath="org.dialogs.newTermsDialog.messages.pleaseReviewLink1AndLink2AndMarkYourConsentBelowToContinueUsingOpendock">
          <template #link1>
            <a
              href="https://loadsmart.com/subscription-and-professional-services-agreement/"
              target="_blank">
              {{ $t('org.dialogs.newTermsDialog.links.loadsmartsTermsConditions') }}
            </a>
          </template>
          <template #link2>
            <a href="https://loadsmart.com/privacy-policy/" target="_blank">
              {{ $t('org.dialogs.newTermsDialog.links.loadsmartsPrivacyPolicy') }}
            </a>
          </template>
        </i18n-t>
      </p>
      <v-checkbox
        x-small
        :label="
          $t(
            'org.dialogs.newTermsDialog.labels.iHaveReadAndAgreeToBeBoundByLoadsmartsTermsConditionsAndSubjectToLoadsmartsPrivacyPolicyInConnectionWithMyUseOfTheOpendockPlatform'
          )
        "
        v-model="confirmed" />
      <p>
        {{ $t('org.dialogs.newTermsDialog.messages.ifYouNeedAnyHelpReachOutToOurSupportTeam') }}
        <a
          href="https://community.loadsmart.com/hc/en-us/community/topics/14812876253715-OpenDock"
          target="_blank">
          {{ $t('org.dialogs.newTermsDialog.links.throughThisLink') }}
        </a>
        .
      </p>
    </template>
    <template #dialog-actions>
      <action-group
        @cancel="close"
        hide-cancel
        :confirm-label="$t('global.buttons.confirm')"
        :disable-confirm="confirmed === false"
        @confirm="handleConfirm"></action-group>
    </template>
  </dialog-base>
</template>
<script>
import dialogMixin from '@satellite/components/mixins/dialogMixin';
import ActionGroup from '@satellite/components/elements/ActionGroup.vue';

/**
 * Dialog for new terms and conditions
 * @displayName New Terms Dialog
 */
export default {
  components: { ActionGroup },
  mixins: [dialogMixin],
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      confirmed: false
    };
  },
  methods: {
    async handleConfirm() {
      this.$emit('confirm');
    }
  }
};
</script>
